import { useEffect, useState } from "react";

const dismissBootScreen = () => {
  document.documentElement.classList.remove("is-booting");
  document.getElementById("boot-screen")?.remove();
};

export const useLoading = (duration) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dismissBootScreen();
      setIsLoading(false);
    }, duration);

    return () => clearTimeout(timeoutId);
  }, [duration]);

  return isLoading;
};
